module.exports = __webpack_public_path__ + "static/media/modernSampleImage.9bba0900.PNG";